import { ReactNode } from 'react';
import { ModalsKeys } from 'global';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { useFetchDealerDetailsPage } from 'modules/aftermarket/partner/hooks';
import { ContactsCard } from './ContactsCard';
import { LocationsCard } from './LocationsCard';
import { ProposalsCard } from './ProposalsCard';
import { DealerInfoCard } from './DealerInfoCard';
import { AddLocationDialog } from '../../dialogs';

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.AftermarketPartnerAddLocationDialog]: <AddLocationDialog />,
};

export const DealerDetailsPage = () => {
  const { partnerLinkId } = useParams<{ partnerLinkId: string }>();

  const routePath = `/partner-dealers/${partnerLinkId}`;

  const account = useSelector((state: any) => state.account);

  const { isLoading, dealerAccount, proposals, partnerLinkMetrics, refetchDealerAccount } = useFetchDealerDetailsPage(
    account.id,
    partnerLinkId
  );

  return (
    <PageContainer loading={isLoading} modals={modalsWithKeys}>
      <Stack gap="2rem">
        <DealerInfoCard dealerAccount={dealerAccount} partnerLinkMetrics={partnerLinkMetrics} />

        <ContactsCard dealerAccount={dealerAccount} refetchDealerAccount={refetchDealerAccount} />

        <LocationsCard dealerAccount={dealerAccount} refetchDealerAccount={refetchDealerAccount} />

        <ProposalsCard proposals={proposals} routePath={routePath} />
      </Stack>
    </PageContainer>
  );
};
